import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { Session } from '../services/session';
import { IResponseCompany } from '@services/company.interface';
import { CoachingFeatureFlagService } from '@services/feature-flags/coaching';

export interface ISafetyOverviewRedirectGuard {
  name: keyof IResponseCompany;
  redirectTo: string;
  enabledWhenFalse?: boolean;
  redirectIfComplianceCoachingEnabled: string;
}

@Injectable()
export class SafetyOverviewRedirectGuard {
  constructor(
    private router: Router,
    private session: Session,
    private coachingFeatureFlagService: CoachingFeatureFlagService,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const config: ISafetyOverviewRedirectGuard = route.data.safetyOverviewRedirectGuard;

    const redirectTo: string = config.redirectTo || '';

    if (this.isBetaFeatureAllowed(config)) {
      return true;
    }
    this.router.navigate([
      this.coachingFeatureFlagService.isComplianceCoachingEnabled() ? config.redirectIfComplianceCoachingEnabled : redirectTo,
    ]);
    return false;
  }

  private isBetaFeatureAllowed(config: ISafetyOverviewRedirectGuard): boolean {
    return config.enabledWhenFalse ?
      !this.session.getCompanyProperty(config.name) :
      this.session.getCompanyProperty(config.name);
  }
}
